<template>
  <app-badge
    v-if="isAcceptance"
    tone="danger"
    variant="solid"
    :label="$t('environment.acceptance_badge')"
    class="shrink-0 uppercase tracking-wide"
    data-test="acceptance-badge"
  />
</template>

<script setup>
  /**
   * AcceptanceBadge — permanent red "acceptatie" sticker beside the logo, so
   * testers can tell acceptance from production at a glance (PI-720). Renders
   * nothing in any other environment. Used by the portal and the admin shell.
   */
  import { getAppEnvironment } from '@/app/runtime';
  import AppBadge from '@/components/ui/feedback/AppBadge.vue';

  defineOptions({ name: 'AcceptanceBadge' });

  const isAcceptance = String(getAppEnvironment() || '').toLowerCase() === 'acceptance';
</script>
